<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">港検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="search" class="btn-search" v-permit.SHARP_PORT_SEARCH>{{
          $t('app.buttons.search')
        }}</v-btn>
        <v-btn to="/m0081/new" v-permit.SHARP_PORT_NEW>{{
          $t('app.buttons.new')
        }}</v-btn>
        <v-btn
          :disabled="selected.length !== 1"
          @click="edit"
          v-permit.SHARP_PORT_EDIT.SHARP_PORT_DETAIL
          >{{ $t('app.buttons.edit') }}</v-btn
        >
        <v-btn
          :disabled="selected.length === 0"
          @click="remove"
          v-permit.SHARP_PORT_DELETE
          >{{ $t('app.buttons.remove') }}</v-btn
        >
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="ISO港CD" v-model="query.code" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="SC港CD" v-model="query.scCode" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field clearable label="名称" v-model="query.name" />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="英語名称"
                v-model="query.englishName"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                label="所在地"
                v-model="query.countryCode"
              />
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-select
                label="輸出入区分"
                :items="[
                  { text: '輸出', value: 'EXPORT' },
                  { text: '輸入', value: 'IMPORT' },
                ]"
                clearable
                v-model="query.tradeType"
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="code"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.scCode }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.englishName }}</td>
          <td>{{ props.item.countryName }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      query: {},
      selected: [],
      results: [],
      loading: false,
      pagination: {
        page: 1,
      },
      headers: [
        { text: 'ISO港CD', value: 'code', sortable: false },
        { text: 'SC港CD', value: 'scCode', sortable: false },
        { text: '名称', value: 'name', sortable: false },
        { text: '英語名称', value: 'englishName', sortable: false },
        { text: '所在地', value: 'countryName', sortable: false },
      ],
    }
  },
  methods: {
    params() {
      return {
        params: {
          ...this.query,
          ...this.$pageable(),
        },
      }
    },
    search() {
      this.pagination.page = 1
      this.load()
    },
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http.get('/ports', this.params()).then((res) => {
        this.pagination.page = res.data.number + 1
        this.pagination.rowsPerPage = res.data.size
        this.pagination.totalItems = res.data.totalElements
        this.results = res.data.content
        this.loading = false
        this.selected = []
      })
    },
    edit() {
      this.$router.push({
        name: 'EditM0081',
        query: { code: this.selected[0].code },
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map((s) => {
              return this.$http.delete(`/ports/${s.code}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
            this.$message('', '削除成功')
          })
        }
      )
    },
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
